import { Box, Grid, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';
import FileGridItem from './FileGridItem';
import FolderGridItem from './FolderGridItem';
import { useTheme } from '@mui/material/styles';

const GridView = ({ folders, files, onFolderClick, onFileClick, onMenuOpen, showPaths = false }) => {
    const [helpButtonVisible, setHelpButtonVisible] = useState(false);
    const theme = useTheme(); 

    return (
        <Box 
            onMouseEnter={() => setHelpButtonVisible(true)}
            onMouseLeave={() => setHelpButtonVisible(false)}
            sx={{ position: 'relative' }}
        >
            {folders.length > 0 || files.length > 0 ? (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 0.5,
                    px: 0.5,
                    color: 'text.primary'
                }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                        {folders.length > 0 && files.length > 0 
                            ? "Folders and Files" 
                            : folders.length > 0 
                                ? "Folders" 
                                : "Files"
                        }
                    </Typography>
                    
                </Box>
            ) : null}
            {/* Help Overlay */}
            

            {/* No data message */}
            {folders.length === 0 && files.length === 0 ? (
                <Typography variant="body1" sx={{ textAlign: 'center', my: 1, color: 'text.secondary' }}>
                    No items to display
                </Typography>
            ) : (
                // Update the Grid container to have more explicit spacing
                <Grid 
                    container 
                    spacing={0.5}  // This should already create gaps between items
                    sx={{
                        '& .MuiGrid-item': {  // Target each grid item specifically
                            paddingTop: 0.5,     // Add more top padding
                            paddingBottom: 0.5   // Add more bottom padding
                        }
                    }}
                >
                    {/* Folder items */}
                    {folders.map((folder, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={`folder-${index}`}>
                            <FolderGridItem 
                                className="file-folder-item"
                                folder={folder} 
                                onClick={onFolderClick} 
                                onMenuOpen={onMenuOpen}
                                showPath={showPaths}
                            />
                        </Grid>
                    ))}
                    
                    {/* File items */}
                    {files.map((file, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={`file-${index}`}>
                            <FileGridItem 
                                className="file-folder-item"
                                file={file} 
                                onFileClick={onFileClick}
                                onMenuOpen={onMenuOpen}
                                showPath={showPaths}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
        </Box>
    );
};

export default GridView;